<template>
  <div
    class="header w100 fff d-flex j-sb "
    style="height:54px;padding:0 12px;font-size:0.875rem; !important"
  >
    <div class="d-flex a-center j-center h100" style="line-height:54px;">
      <div class="main-text-color h100"><<</div>
      <div
        class=" h100"
        style="margin-left:20px;border-bottom:2px solid #006EC7;color#000;"
      >
        {{title}}
      </div>
    </div>
    <div class="d-flex a-center main-text-color">>></div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props:{
    title:{
      type:String,
      required:true
    }
  },
  data() {
    return {

    };
  },
};
</script>

<style scoped lang="less" scoped></style>
